import {
  CarouselProductClickPayload,
  CarouselProductVisiblePayload,
} from '@noths/polaris-client-ribbons-design-system';
import { createAction } from '@reduxjs/toolkit';

export const recommendedProductsShelfVisible = createAction<CarouselProductVisiblePayload>(
  'recommendedProductsShelf/onVisible',
);

export const recommendedProductsShelfProductClick = createAction<CarouselProductClickPayload>(
  'recommendedProductsShelf/productClick',
);
